import Layout from "../../../Components/Layout";
import Publish from "../../../Components/EventMgt/Publish";
import CreateEventFormTab from "../../../Components/EventMgt/CreateEvent/CreateEventFormTab";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
const PublishPage = () => {
  const params = useParams();
  const { eventId } = params;
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (
      eventId === "undefined" ||
      eventId === undefined ||
      eventId === null ||
      !eventId
    ) {
      navigate("/");
      return;
    }
  }, [location || eventId]);

  return (
    <Layout
      BackAction="/organizer/MyEvents"
      Heading="Publish"
      TitleClassName="event-create-title"
      HeadClassName="event-page-head event-create-head"
      CreateHead
      activeMenuId="create-event"
      ExtraclassName="event-create-panel"
    >
      <div className="eventCreationFrom">
        <CreateEventFormTab Id="publish" />
        <Publish />
      </div>
    </Layout>
  );
};
export default PublishPage;
